import { render, staticRenderFns } from "./PersonhoodFullPage.vue?vue&type=template&id=feddc2d2&"
import script from "./PersonhoodFullPage.vue?vue&type=script&lang=js&"
export * from "./PersonhoodFullPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports